__turbopack_context__.v({
  "checkIcon": "_7xOtNa_checkIcon",
  "content": "_7xOtNa_content",
  "errorH1": "_7xOtNa_errorH1",
  "errorH2": "_7xOtNa_errorH2",
  "h1": "_7xOtNa_h1",
  "h2": "_7xOtNa_h2",
  "main": "_7xOtNa_main",
  "mainBody": "_7xOtNa_mainBody",
  "openHours": "_7xOtNa_openHours",
  "phoneNumberLink": "_7xOtNa_phoneNumberLink",
  "phoneNumberWrap": "_7xOtNa_phoneNumberWrap",
  "thanksBody": "_7xOtNa_thanksBody",
  "thanksH1": "_7xOtNa_thanksH1",
  "thanksMain": "_7xOtNa_thanksMain",
});
